import React, { useEffect, useState } from "react";
import * as functions from "../../utils/functions"

// assets Images
import bgImage from "../../assets/bg/4.png";
import mobileBgImage from "../../assets/bg/5.png";
import xureIcon from "../../assets/logo.png";
import googlePlay from "../../assets/xure-icon/googlePlay.png";
import appStore from "../../assets/xure-icon/appStore.png";
import successIcon from "../../assets/xure-icon/icon-success-payment.png";

// icons
import { IoMdCalendar } from "react-icons/io";
import { RiEditBoxLine } from "react-icons/ri";
import { app_universal_link } from "../../utils/varConstant";

const Loader = () => (
  <div className="flex justify-center items-center w-full h-full bg-[#2f2f2f] animate-pulse text-white text-sm">
    Loading...
  </div>
);

const RedirectMePayment = () => {
  const [bgImageUrl, setBgImageUrl] = useState(bgImage);
  const [amount, setAmount] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [countdown, setCountdown] = useState(20);

  useEffect(() => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    const amountParam = params.get('amount');
    const currencyParam = params.get('currency');

    if (amountParam) setAmount(amountParam);
    if (currencyParam) setCurrency(currencyParam);
  }, []);

  useEffect(() => {
    if (countdown === 0) {
      window.location.href = `${app_universal_link}/success`;
      return;
    }
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [countdown]);

  useEffect(() => {
    const updateBackground = () => {
      const isMobile = window.innerWidth <= 640;
      setBgImageUrl(isMobile ? mobileBgImage : bgImage);

    };

    updateBackground(); // Run initially
    window.addEventListener("resize", updateBackground);

    return () => window.removeEventListener("resize", updateBackground);
  }, []);

  const navigateToApp = () => {
    window.location.href = `${app_universal_link}/success`;
  }

  const formatAmount = (amountStr) => {
    if (!amountStr) return '';
    return Number(amountStr).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  return (
    <div
      className="h-auto min-h-[100vh] flex flex-col gap-4 justify-center items-center sm:p-2 p-4"
      style={{
        backgroundImage: `url(${bgImageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <img src={xureIcon} className="w-32" />
      <div className="w-full gap-4 flex flex-col justify-center items-center md:w-[600px] h-auto rounded-xl overflow-hidden bg-[#373737] p-7">
        <img src={successIcon} className="w-32" />
        <h1 className="text-xl text-white font-extrabold">Payment Successful!</h1>
        <div className="w-full gap-1 flex flex-col justify-center items-center h-auto rounded-xl overflow-hidden bg-[#2F2F2F] p-4">
          <h6 className="text-sm text-white font-medium">Amount Paid</h6>
          <h1 className="text-3xl text-[#F7D091] font-extrabold">
            {/* {`${currency} ${amount}`} */}
            {`${currency} ${formatAmount(amount)}`}
          </h1>
        </div>
        <h6 className="text-xs text-[#D9D9D9] font-normal text-center">
          Thank you! Your payment has been successfully completed.
        </h6>
      </div>
      <div className="mx-4 md:mx-16 text-center">
        <button className="w-full bg-[#F7D091] rounded-[30px] py-2 font-bold" onClick={navigateToApp}>Back to Merchant</button>
        <div className="text-white mt-2">You will be redirected to the merchant site after {countdown}s</div>
        <small className="text-white mt-3">DOWNLOAD NOW!</small>
        <div className="flex gap-2 justify-center my-1">
          <a href="https://play.google.com/store/apps/details?id=com.xdeal&pli=1" target='_blank' className='btn-animation'>
            <img src={googlePlay} className="h-[34px]" />
          </a>
          <a href="https://apps.apple.com/ph/app/xure/id6463198157" target='_blank' >
            <img src={appStore} className="h-[34px]" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default RedirectMePayment;
